module.exports = __webpack_public_path__ + "img/清河头乡.18d0c113.png";